import axiosInstance from ".";

export const getBlogs = ({ queryKey }) => {
  const [queries] = queryKey;
  return axiosInstance.get(`/blogs`, { params: queries });
};

export const addBlogs = (data) => {
  return axiosInstance.post("/blogs", data);
};

export const updateBlogs = (data) => {
  const { id, ...payload } = data;
  return axiosInstance.put(`/blogs/${id}`, payload);
};

export const deleteBlog = (id) => {
  return axiosInstance.delete(`/blogs/${id}`);
};

export const getBlogsBySlug = ({ queryKey }) => {
  const [queries] = queryKey;
  return axiosInstance.get(`/blogs`, { params: queries });
};
